customElements.define(
  'main-product',
  class MainProduct extends HTMLElement {
    connectedCallback() {
      this.setNodeSelectors();
      this.setEventListeners();
      this.setRecentlyViewedState();
    }

    /**
     * Sets the node selectors.
     */
    setNodeSelectors() {
      this.nodeSelectors = {
        form: this.querySelector('[js-main-product="form"]'),
      };
    }

    /**
     * Sets the event listeners.
     */
    setEventListeners() {
      if (this.nodeSelectors.form) {
        this.nodeSelectors.form.addEventListener('variant', (event) => {
          this.setQueryParam(event.detail);
          this.setVariantSection(event.detail);
        });
      }
    }

    /**
     * Fetches and returns the variant's section content.
     * @param {Object} variant - The variant object.
     * @returns {Promise}
     */
    fetchVariantSection(variant) {
      if (this.controller) {
        this.controller.abort('Aborting variant section fetch');
      }

      this.controller = new AbortController();

      return fetch(`${window.location.pathname}?section_id=${this.dataset.sectionId}&variant=${variant.id}`, {
        signal: this.controller.signal,
      })
        .then((response) => response.text())
        .catch(() => {});
    }

    /**
     * Sets the variant section.
     * - Fetches the section content, and injects it.
     * @param {Object} variant - The variant object.
     */
    async setVariantSection(variant) {
      this.classList.add('is-loading');

      const section = await this.fetchVariantSection(variant);
      const html = new DOMParser().parseFromString(section, 'text/html');
      const main = html.querySelector('main-product');

      if (!main) {
        return;
      }

      replaceElement(this, main, '[js-main-product="gallery"]');
      replaceProductForm(this.querySelector('product-form'), main.querySelector('product-form'));

      requestAnimationFrame(() => {
        setAllDynamicImages(this);
      });

      this.classList.remove('is-loading');
    }

    /**
     * Sets the variant query parameter.
     * @param {Object} variant - The variant object.
     */
    setQueryParam(variant) {
      const params = new URLSearchParams(window.location.search);

      params.set('variant', variant.id);

      window.history.replaceState(null, null, `?${params.toString()}`);
    }

    /**
     * Pushes the product to the recently viewed state.
     */
    setRecentlyViewedState() {
      const products = JSON.parse(localStorage.getItem('recently-viewed-products')) ?? [];

      if (products.includes(this.dataset.productId)) {
        return;
      }

      localStorage.setItem('recently-viewed-products', JSON.stringify([...products, this.dataset.productId]));
    }
  }
);
